<template>
  <!--   <div class="w-72 min-h-screen bg-beige-academy-500 transform ease-in
    duration-500 mb-20 transition border-t-2 border-beige-academy-400">
    <div class="text-black text-xl">
    </div>
  </div> -->
  <div
    class="fixed inset-0 overflow-hidden"
    aria-labelledby="slide-over-title"
    role="dialog"
    aria-modal="true"
  >
    <on-click-outside :handler="closeMenu">
    <div class="absolute inset-0 overflow-hidden">
      <div class="absolute inset-0" aria-hidden="true"></div>

      <div
        class="
          pointer-events-none
          fixed
          inset-y-0
          right-0
          flex
          max-w-full
          pl-10
          sm:pl-16
        "
      >
        <div class="pointer-events-auto w-screen max-w-md">
          <div
            class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl pt-8"
          >
            <ul
              role="list"
              class="flex-1 divide-y divide-gray-200 overflow-y-auto"
            >
              <li>
                <messages></messages>
             <!--    <div class="group relative flex items-center py-6 px-5">
                  <a href="#" class="-m-1 block flex-1 p-1">
                    <div
                      class="absolute inset-0 group-hover:bg-gray-50"
                      aria-hidden="true"
                    ></div>
                    <div class="relative flex min-w-0 flex-1 items-center">
                      <span class="relative inline-block flex-shrink-0">
                        <img
                          class="h-10 w-10 rounded-full"
                          src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt=""
                        />
                        <span
                          class="
                            bg-green-400
                            absolute
                            top-0
                            right-0
                            block
                            h-2.5
                            w-2.5
                            rounded-full
                            ring-2 ring-white
                          "
                          aria-hidden="true"
                        ></span>
                      </span>
                      <div class="ml-4 truncate">
                        <p class="truncate text-sm font-medium text-gray-900">
                          Leslie Alexander
                        </p>
                        <p class="truncate text-sm text-gray-500">
                          @lesliealexander
                        </p>
                      </div>
                    </div>
                  </a>
                  <div
                    class="relative ml-2 inline-block flex-shrink-0 text-left"
                  >
                    <button
                      type="button"
                      class="
                        group
                        relative
                        inline-flex
                        h-8
                        w-8
                        items-center
                        justify-center
                        rounded-full
                        bg-white
                        focus:outline-none
                        focus:ring-2
                        focus:ring-indigo-500
                        focus:ring-offset-2
                      "
                      id="options-menu-0-button"
                      aria-expanded="false"
                      aria-haspopup="true"
                    >
                      <span class="sr-only">Open options menu</span>
                      <span
                        class="
                          flex
                          h-full
                          w-full
                          items-center
                          justify-center
                          rounded-full
                        "
                      >
                        <svg
                          class="
                            h-5
                            w-5
                            text-gray-400
                            group-hover:text-gray-500
                          "
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0
                            010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                          />
                        </svg>
                      </span>
                    </button>
                    <div
                      class="
                        absolute
                        top-0
                        right-9
                        z-10
                        w-48
                        origin-top-right
                        rounded-md
                        bg-white
                        shadow-lg
                        ring-1 ring-black ring-opacity-5
                        focus:outline-none
                      "
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu-0-button"
                      tabindex="-1"
                    >
                      <div class="py-1" role="none">
                        <a
                          href="#"
                          class="text-gray-700 block px-4 py-2 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="options-menu-0-item-0"
                          >View profile</a
                        >
                        <a
                          href="#"
                          class="text-gray-700 block px-4 py-2 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="options-menu-0-item-1"
                          >Send message</a
                        >
                      </div>
                    </div>
                  </div>
                </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      </on-click-outside>
  </div>
</template>

<script>
import OnClickOutside from '@/directives/OnClickOutside';
import Messages from '../Messages.vue';

export default {
  data() {
    return {
      isPanelVisible: false,
    };
  },

  components: {
    Messages,
    OnClickOutside,
  },

  methods: {
    closeMenu() {
      this.$emit('input', false);
    },
  },
};
</script>
